import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

const faqItemSchema = buildEntrySchemaFor('faqItem', {
  fields: z.lazy(() =>
    z.object({
      question: z.string(),
      answer: RichTextSchema,
    }),
  ),
})

export const faqGroupSchema = buildEntrySchemaFor('faqGroup', {
  fields: z.lazy(() =>
    z.object({
      heading: z.string().optional(),
      faqs: z.array(faqItemSchema),
    }),
  ),
})

export type FaqGroup = z.infer<typeof faqGroupSchema>
